module.exports = __webpack_public_path__ + "img/1.4c0457a2.jpg";